export default {
  path: "/organization",
  component: () => import("@/views/LayoutView.vue"),
  children: [
    {
      path: "",
      redirect: "my",
    },
    {
      path: "my",
      props: {
        getDataUrl: "/my",
      },
      component: () => import("@/components/default/view/DefaultView.vue"),
    },

    {
      path: ":dir(staff)/(list)*",
      component: () => import("@/views/organization/staff/StaffList.vue"),
    },

    {
      path: ":dir(groupe)/view/all",
      component: () =>
        import("@/views/organization/groupView/GroupAll.vue"),
    },

    {
      path: ":dir(act-services)/(list)*",
      component: () => import("@/views/organization/actService/ActServicesList.vue"),
    },

    {
      path: ":dir(act-services)/view/:id",
      component: () => import("@/views/organization/actService/ActServiceView.vue"),
    },

    {
      path: ":dir(groupe)/view/:id",
      component: () =>
        import("@/views/organization/groupView/GroupView.vue"),
    },

    {
      path: ":dir(place)/:subdir(applications)/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
      props: {
        getDataUrl: "place/applications",
      },
    },
    {
      path: ":dir(journal)/view/:id",
      component: () =>
        import("@/views/organization/journal/JournalView.vue"),
    },
    {
      path: ":dir(tickets)/view/:id",
      component: () => import("@/views/superadmin/ticket/TicketView.vue"),
    },
    {
      path: ":dir(monitoring)",
      component: () => import("@/views/organization/monitoring/OrganizationMonitoring.vue"),
    },
    {
      path: ":dir(branches)/:id",
      component: () => import("@/views/head-department/monitoring/BranchDetails.vue"),
      props: true
    },
    {
      path: ":dir(act)/view/:id",
      component: () => import("@/views/organization/tabel/TabelView.vue"),
    },
    {
      path: ":dir(gos-zakaz)",
      component: () => import("@/components/default/view/DefaultView.vue"),
    },
    {
      path: ":dir/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
    },
    {
      path: ":dir/view/:id",
      component: () => import("@/components/default/view/DefaultView.vue"),
    },
  ],
};
